<template>
  <div class=" operation_log">
    <div class="topSearch">
      <div class="innerSearch">
        <el-input placeholder="Search" v-model="input1" class="input-with-select" id="topInput">
          <el-select v-model="selects" slot="prepend" style="width: 100px">
            <el-option label="All" value=""></el-option>
            <el-option label="Task" value="Task"></el-option>
            <el-option label="Address" value="Address"></el-option>
            <el-option label="DriverGroup" value="DriverGroup"></el-option>
          </el-select>
        </el-input>
      </div>
      <div style="margin: 8px">
        <el-button type="primary" @click="searchHandle">搜索</el-button>
      </div>
    </div>
    <div class="log_table">
      <el-table
        :data="oper_log_data"
        style="width: 100%">
        <el-table-column
          prop="id"
          label="ID"
          >
        </el-table-column>
        <el-table-column
          prop="mod"
          label="控制器模块"
          >
        </el-table-column>
        <el-table-column
          prop="remark"
          label="内容">
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="创建时间">
        </el-table-column>
      </el-table>
    </div>
      <div class="btomPagin" >
        <div class="innerLeft">{{page}} - <span>{{oper_log_data.length}}</span> of <span>{{total}}</span> items</div>
        <div>
          <el-pagination
            :page-size="10"
            layout="prev, pager, next, jumper"
            :total="total"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
  </div>
</template>

<script>
import {getOperationList} from "@/api/toolBox";

export default {
  name: "operationLog",
  data(){
    return{
      input1:'',
      selects:'',
      oper_log_data:[],
      page:1,
      total:''
    }
  },
  created() {
    this.searchHandle()
  },
  methods:{
    getOperList(){
      getOperationList({
        page:this.page,
        pageSize:10,
        controller:this.selects,
        searchContent:this.input1
      }).then(res=>{
        this.oper_log_data = res.data
        this.total = res.total
      })
    },
    searchHandle(){
      this.page = 1
      this.getOperList()
    },
    handleCurrentChange(val){
      this.page = val
      this.getOperList()
    }
  }
}
</script>

<style scoped lang="less">
.operation_log{
  .topSearch{
    display: flex;
    .innerSearch {
      margin: 8px;
      width: 20%;
    }
    .topSeach{
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      /deep/ .el-input--prefix .el-input__inner{
        padding-left: 88px;
      }
      /deep/ .el-input__prefix{
        color: #1F2D42;
      }
      .long_search{
        /deep/.el-input__inner{
          padding-left: 115px!important;
        }
      }
      .long_searchs{
        /deep/.el-input__inner{
          padding-left: 133px!important;
        }
      }
      .innerSearch{
        margin: 8px;
        /deep/.el-cascader{
          line-height: 0;
        }
        .innerTime{
          /deep/.el-input__prefix{
            position: absolute;
            top: 0;
            right: 12px;
            left: auto;
          }
          /deep/ .el-input--prefix .el-input__inner{
            padding-left: 12px;
          }
          /deep/.el-input__icon{
            //position: absolute;
            //right: 12px;
            color: #D65953;
          }
        }
        .from{
          /deep/.el-input__inner{
            padding-left: 75px!important;
          }
        }
        .to{
          /deep/.el-input__inner{
            padding-left: 55px!important;
          }
        }
      }
      .cascader{
        position: relative;
        /deep/.el-input__inner{
          padding-left: 80px;
        }
        .slot{
          position: absolute;
          padding-left: 24px;
          font-size: 14px;
          top: 5px;
        }
      }
      .ex{
        width: 300px;
        /deep/ .el-input--prefix .el-input__inner{
          padding-left: 110px;
        }
      }
    }
  }
  .log_table{
    margin-top: 16px;
  }
  .btomPagin{
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    padding-left: 16px;
    .innerLeft{
      font-size: 16px;
      font-family: SFPro-Regular, SFPro;
      font-weight: 400;
      color: #1F2D42;
      line-height: 20px;
    }
  }
}
</style>
